import fr from './fr.json';
import en from './en.json';
import de from './de.json';

const LANGUAGES = { fr, en, de };

export function getDefaultLang(): string {
    const docLang = document.documentElement.lang;
    return docLang?.length ? docLang : 'fr';
}

export function getMessage(language: string, key: string, ...args: string[]): string {
    const dict = LANGUAGES[language?.split('-')[0] || 'fr'] || fr;
    const keys = key.split('.');
    let text = dict;
    keys.map(k => {
        text = text[k];
    });
    return typeof(text) === 'string' ? format(text, ...args) : key;
}

function format(message: string, ...args: string[]): string {
  if (args.length === 0) {
    return message;
  } else {
    return message.replace(/{(\d+)}/g, (match, number) => typeof args[number] !== 'undefined' ? args[number] : match);
  }
}
